export class API_ENDPOINT_KEYS {
  static readonly getFormConfig = 'getFormConfig';
  static readonly getFormSubmissionConfig = 'getFormSubmissionConfig';
  static readonly getFormSubmissionConfigAndResponse = 'getFormSubmissionConfigAndResponse';
};

export class API_ENDPOINTS {
  static readonly configuration = {
    default: 'FormConfiguration/GetConfiguration',
    custom: 'FormConfiguration/GetCustomConfig'
  } as const;

  static readonly formResponse = {
    getConfigAndResponse: 'FormResponse/GetConfigAndResponse',
    save: 'FormResponse/Save',
    getAvailableForms: 'FormResponse/GetAvailableForms',
    sendResponseSavedNotification: 'FormResponse/SendResponseSavedNotification'
  } as const;

  static readonly address = {
    search: 'Address/Search',
    lga: 'Address/Lga'
  } as const;

  static readonly user = {
    getLoggedInUser: 'User/GetLoggedInUser'
  } as const;

  static readonly pbi = {
    embedInfo: '/PowerBI/EmbedInfo'
  } as const;

  static readonly dashboard = {
    getReferenceDataCategories: 'Dashboard/GetReferenceDataCategories',
  } as const;

  static readonly referenceData = {
    getConfigAndResponse: 'ReferenceData/GetResponseAndConfig',
    save: 'ReferenceData/Save',
    bulkSave: 'ReferenceData/BulkSave',
  } as const;

  static readonly maintenanceRequest = {
    getConfigAndResponse: 'MaintenanceRequest/GetResponseAndConfig',
    save: 'MaintenanceRequest/Save',
  } as const;
};
